import { IdentityDto } from '@interhyp/platform-auth';
import { isValidCompanyForInterimOfferTab } from '@interhyp/shared-interim-portal';

import { LocalModule } from '../../interfaces/LocalModule';
import { Remote } from '../../interfaces/Remote';
import ConsentManagerModule from '../../modules/ConsentManager/ConsentManager.module';
import DocumentsRedirectModule from '../../modules/DocumentsRedirect/DocumentsRedirect.module';
import InitialDataInputModalModule from '../../modules/InitialDataInput/InitialDataInputModal.module';
import IntentRedirectModule from '../../modules/IntentRedirect/IntentRedirect.module';
import MarketOverviewModule from '../../modules/MarketOverview/MarketOverview.module';
import OffersModule from '../../modules/Offers/Offers.module';

export const remotes: Remote[] = [
  // Core modules
  {
    name: 'module_portal',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-portal/remoteEntry.js',
  },
  // External modules
  {
    name: 'module_account',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-account/remoteEntry.js',
  },
  {
    name: 'module_intent_data',
    imports: ['./ModuleInterimConfiguration'],
    source: '/remotes/module-intent-data/remoteEntry.js',
  },
  {
    name: 'module_documents',
    imports: ['./ModuleInterimConfiguration'],
    source: '/remotes/module-documents/remoteEntry.js',
  },
  {
    name: 'plugin_estate_bank_valuation',
    imports: ['./PluginConfiguration'],
    source: '/remotes/plugin-estate-bank-valuation/remoteEntry.js',
  },
  {
    name: 'plugin_estate_valuation',
    imports: ['./PluginConfiguration'],
    source: '/remotes/plugin-estate-valuation/remoteEntry.js',
  },
  {
    name: 'module_credit_communication',
    imports: ['./LoanPartnerCommunication'],
    source: '/remotes/module-credit-communication/remoteEntry.js',
  },
  {
    name: 'module_credit_modules',
    imports: ['./CreditLogbook'],
    source: '/remotes/module-credit-modules/remoteEntry.js',
  },
  {
    name: 'module_preinquiry',
    imports: ['./PreinquiryCreateWorkflow', './PreinquiryLogbook', './PreinquiriesOverview'],
    source: '/remotes/module-preinquiry/remoteEntry.js',
  },
  {
    name: 'module_create_financial_certificate',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-create-financial-certificate/remoteEntry.js',
  },
  {
    name: 'module_insurance',
    imports: ['./ModuleConfiguration'],
    source: '/remotes/module-insurance/remoteEntry.js',
    onlyOnStages: ['dev'],
  },
  {
    name: 'module_mortgage_request',
    imports: ['./InitialDataInputConfiguration', './ArrangeAppointmentConfiguration'],
    source: '/remotes/module-mortgage-request/remoteEntry.js',
  },
];

// after this date, the marketoverview route is hidden for ALL users, there is a follow up task to remove the dependency after the cutoff date
// https://atlas.interhyp.de/jira/browse/EVA-8249
export const MARKETOVERVIEW_CUTOFF_DATE = new Date(2024, 11, 12).getTime();

export const modules: LocalModule[] = [
  { module: IntentRedirectModule },
  { module: DocumentsRedirectModule },
  {
    module: MarketOverviewModule,
    // the hide logic is similar to plugin-generic-partner and has to be adapted to reduce code duplication
    permissions: ['showCompare'],
    shouldRender: (): boolean => Date.now() < MARKETOVERVIEW_CUTOFF_DATE,
  },
  {
    module: OffersModule,
    // the hide logic is similar to plugin-generic-partner and has to be adapted to reduce code duplication
    permissions: ['showBids'],
    shouldRender: (identity?: IdentityDto): boolean => {
      return isValidCompanyForInterimOfferTab(identity?.companyId);
    },
  },
  {
    module: InitialDataInputModalModule,
  },
  {
    module: ConsentManagerModule,
    shouldRender: (): boolean => {
      return localStorage.getItem('show-new-consent-modal') === 'true';
    },
  },
];
